const now = new Date()



function genNoWork() {
    let noWork = [
        [1, 1, 26],
        [11, 27, 25],
        [9, 1, 25],
        [11, 11, 25],
        [12, 25, 25],


    ]
    return noWork.map(day => {

        return {

            allday: true,
            title: 'No Work',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, 0)
        }
    })

}

function genGLC() {
    let glc = [
        [9, 6, 25],
        [9, 13, 25],
        [9, 20, 25],
        [9, 27, 25],
        [10, 4, 25],
        [10, 11, 25],
        [10, 25, 25],
        [11, 1, 25],
        [11, 8, 25],
        [11, 15, 25],
        [11, 22, 25],
        [12, 13, 25],
        [12, 20, 25],
        [1, 10, 26],
        [1, 17, 26],
        [1, 24, 26],
        [1, 31, 26],
        [2, 7, 26],
        [2, 21, 26],
        [2, 28, 26],
        [3, 7, 26],
        [3, 14, 26],
        [3, 21, 26],
        [3, 28, 26],
        [4, 11, 26],
        [4, 18, 26],
        [4, 25, 26],
        [5, 2, 26],
        [5, 9, 26],
        [5, 16, 26],

    ]
    return glc.map(day => {

        return {

            allday: true,
            title: 'GLC',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, 0)
        }
    })

}

function genNoSchool() {
    let noSchoolDays = [
        [9, 1, 25],
        [9, 23, 25],
        [10, 2, 25],
        [10, 17, 25],
        [10, 20, 25],
        [11, 3, 25],
        [11, 26, 25],
        [11, 27, 25],
        [11, 28, 25],
        [12, 24, 25],
        [12, 25, 25],
        [12, 26, 25],
        [12, 29, 25],
        [12, 30, 25],
        [12, 31, 25],
        [1, 1, 26],
        [1, 2, 26],
        [1, 19, 26],
        [1, 26, 26],
        [2, 16, 26],
        [2, 17, 26],
        [3, 20, 26],
        [3, 30, 26],
        [3, 31, 26],
        [4, 1, 26],
        [4, 2, 26],
        [4, 3, 26],
        [4, 6, 26],
        [4, 15, 26],
        [5, 25, 26],
        [5, 27, 26],
        [6, 18, 26],
        [6, 19, 26],
    ]
    return noSchoolDays.map(day => {

        return {

            allday: true,
            title: 'No School',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, 0)
        }
    })

}

export default [

    ...genNoSchool(),
    ...genGLC(),
    ...genNoWork(),
    {

        allday: true,
        title: 'Early Release',
        start: new Date("9/26/2025"),
        end: new Date("9/26/2025")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/24/2025"),
        end: new Date("11/24/2025")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/25/2025"),
        end: new Date("11/25/2025")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("2/27/2026"),
        end: new Date("2/27/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("6/17/2026"),
        end: new Date("6/17/2026")
    },
    {

        allday: true,
        title: 'First Day of School',
        start: new Date("8/25/2026"),
        end: new Date("8/25/2026")
    },
    /*
    {

        allday: true,
        title: 'Beth Weekend',
        private: true,
        start: new Date("10/18/2025"),
        end: new Date("10/22/2025")
    },
    {
        allday: true,
        title: 'Ren Fest',
        start: new Date("10/5/2025"),
        private: true,
        end: new Date("10/5/2025")
    },
    {
        allday: true,
        title: 'Beth Date',
        start: new Date("9/5/2025"),
        private: true,
        end: new Date("9/5/2025")
    },
    {
        allday: true,
        title: 'Beth`s Katie',
        start: new Date("9/19/2025"),
        private: true,
        end: new Date("9/20/2025")
    },
    {
        allday: true,
        title: 'Glazing',
        start: new Date('10/3/2025'),
        private: true,
        end: new Date('10/3/2025')
    },

*/

]